export default class Inquiry {

  uuid: string
  status: string
  created: Date

}

// lastdays = 0 // Last 0 days (Today)
// lastdays = 1 // Last 1 day (Yesterday)
// lastdays = 7 // Last 7 days
// ago = 24*60*60 // Last 24 hours
// range = []
